

@if (showSurvey && typeformid) {
  <div >
    <div [attr.data-tf-widget]="typeformid" data-tf-opacity="100" data-tf-iframe-props="title=Hemisphere Feedback"
      data-tf-on-submit="submitted"
    data-tf-transitive-search-params data-tf-medium="snippet" [attr.data-tf-hidden]="getHidden()" style="width:100%;height:500px;"></div>
  </div>
}

@if (!showSurvey) {
  <div class="content-container">
    <div class="text-container wide-container">
      <div [ngClass]="controller.getClassObject(page, [])">
        @for (element of page.elements; track element) {
          @if (element.type == 'header') {
            <h1>{{ element.value }}</h1>
          }
          @if (element.type == 'br') {
            <br />
          }
          @if (element.type == 'hr') {
            <hr />
          }
          @if (element.type == 'ul') {
            <ul>
              @for (el of element.elements; track el) {
                <li>{{ el.value }}</li>
              }
            </ul>
          }
          @if (element.type == 'p') {
            <p>{{ element.value }}</p>
          }
        }
      </div>
      <div class="button-container">
        @if (showSurveyButton) {
          <button
            id="completeModule"
            (click)="onGoToSurvey()"
            class="btn btn-outline-primary btn-outline hover active"
            style="padding-right: 18px; padding-left: 21px"
            >
            SHARE YOUR FEEDBACK
          </button>
        }
        @if (page.properties && page.properties.haveContentLibraryButton) {
          <button id='gotoContentLibrary' (click)="gotoLibrary()" class="btn btn-outline-primary btn-outline next" autocus>GO TO CONTENT LIBRARY</button>
        }
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
}
<app-progress-bar [progressValue]="controller.getProgress()"></app-progress-bar>
